<script>
	
	import { MaterialApp } from 'svelte-materialify';
	import Index from './index.svelte';
	
</script>

<main>
	<MaterialApp theme="light">

		<Index />
	
	</MaterialApp>
</main>

<style>

	main {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

</style>